import { MediaBasicDataDto, MediaPlacementType, UpdateMediaBasicDto } from '@sr/dto';
import { FormikErrors } from 'formik';
import { VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';

export interface FormValues {
  name: string;
  mediaTypeId: number | '';
  placement: string;
  countryId: number | null;
  regionId: number | null;
  cityId: number | null;
  parentMediaId: number | null;
}

export const fromMedia = (formData: MediaBasicDataDto): FormValues => ({
  mediaTypeId: formData.mediaType.id,
  name: formData.name,
  placement: formData.placement as MediaPlacementType || '',
  cityId:  formData.cityId,
  countryId:  formData.countryId,
  regionId: formData.regionId,
  parentMediaId: formData.parentMediaId,
});

export const toUpdateMedia = (id: number, formData: FormValues): UpdateMediaBasicDto => ({
  id: id,
  name: formData.name,
  typeId: Number(formData.mediaTypeId),
  placement: formData.placement as MediaPlacementType,
  cityId:  formData.cityId,
  countryId: formData.countryId,
  regionId: formData.regionId,
  parentMediaId: formData.parentMediaId ? formData.parentMediaId : null,
});

export const emptyValues: FormValues = {
  name: '',
  mediaTypeId: '',
  placement: '',
  countryId: null,
  regionId: null,
  cityId: null,
  parentMediaId: null,
};


export const validate = (values: FormValues) => {
  let errors: FormikErrors<FormValues> = {};

  const required = 'Обязательное поле';

  if (!values.name)
    errors.name = required;
  else if (values.name.length < 3)
    errors.name = 'Минимум 3 символа';
  else if (values.name.length >= 256)
    errors.name = 'Максимум 256 символов';


  if (!values.mediaTypeId)
    errors.mediaTypeId = required;

  // Валидация в зависимости от выбранного размещения
  if (values.placement === 'federal' && !values.countryId) {
    errors.countryId = VALIDATION_REQUIRED_FIELD;
  }
  
  if (values.placement === 'regional' && !values.regionId) {
    errors.regionId = VALIDATION_REQUIRED_FIELD;
  }
  
  if (values.placement === 'local' && !values.cityId) {
    errors.cityId = VALIDATION_REQUIRED_FIELD;
  }

  return errors;
};
